import React from 'react';
import { Routes } from '@common/constants';
import NextStepButton from './NextStepButton';
import { SpaPackageAvailability } from './SpaPackageAvailability';
import { SpaPackageExtras } from './SpaPackageExtras';
import { SubmitButton } from './SubmitButton';

const AVAILABILITY_KEY = 'availability';
const EXTRAS_KEY = 'extras';
const NO_KEY = '';

export const getSteps = ({ extras }) => {
  const extrasStep = [{ key: EXTRAS_KEY, id: 'spa.extrasStep' }];

  return [
    { key: AVAILABILITY_KEY, id: 'spa.availabilityStep' },
    ...(extras.length ? extrasStep : []),
  ];
};

export const getCurrentStep = ({
  arrivalTime,
  unavailable,
  bookingStep = '',
  spaDayId,
  property,
  extras,
  language,
  setUnavailable,
  handleCloseModal,
  entity,
  router,
  maxGuests = Infinity,
}) => {
  const goToDetailPage = () =>
    router.push({
      pathname: Routes.SPA_DAY_DETAIL,
      query: {
        id: spaDayId,
      },
    });

  const goToAvailabilityPage = () =>
    router.push({
      pathname: Routes.SPA_DAY_BOOKING,
      query: {
        id: spaDayId,
        bookingStep: 'availability',
      },
    });

  const steps = {
    [AVAILABILITY_KEY]: {
      form: (
        <SpaPackageAvailability
          spaPackageId={spaDayId}
          property={property}
          setUnavailable={setUnavailable}
          language={language}
          maxGuests={maxGuests}
          unavailable={unavailable}
        />
      ),
      stickyButton: extras?.length ? (
        <NextStepButton
          nextUrl={{
            pathname: Routes.SPA_DAY_BOOKING,
            query: {
              id: spaDayId,
              bookingStep: 'extras',
            },
          }}
          disabled={!arrivalTime || unavailable}
        />
      ) : (
        <SubmitButton
          entity={entity}
          property={property}
          language={language}
          disabled={unavailable}
          closeModal={handleCloseModal}
        />
      ),
      goToPreviousStep: goToDetailPage,
      titleId: 'spa.package.availabilityTitle',
    },
    [EXTRAS_KEY]: {
      form: <SpaPackageExtras extras={extras} />,
      stickyButton: (
        <SubmitButton
          entity={entity}
          property={property}
          language={language}
          closeModal={handleCloseModal}
          buttonTextId={'booking.continue'}
        />
      ),
      goToPreviousStep: goToAvailabilityPage,
      titleId: 'spa.package.extrasTitle',
    },
    [NO_KEY]: {
      form: null,
      stickyButton: null,
      goToPreviousStep: null,
      titleId: '',
    },
  };
  return steps[bookingStep];
};
